<template>
  <svg
    class="icon"
    width="43"
    height="42"
    viewBox="0 0 43 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_55_2125)">
      <path
        class="bg"
        d="M21.1233 41.2466C32.5133 41.2466 41.7466 32.0133 41.7466 20.6233C41.7466 9.23337 32.5133 0 21.1233 0C9.73337 0 0.5 9.23337 0.5 20.6233C0.5 32.0133 9.73337 41.2466 21.1233 41.2466Z"
        fill="#BBBBBB"
      />
      <path
        d="M28.1667 32H24.3201V12.963H22.4092C20.5142 12.963 19.9004 13.4938 19.6794 13.5802C19.4583 13.6667 17.8699 14.6865 17.7685 16.321C17.6444 18.321 18.1655 19.5802 19.1086 20.6667C19.863 21.5358 22.1528 23.0535 23.2033 23.7037L17.6692 32H13.5C15.1544 29.5144 18.4633 24.5481 18.4633 24.5679C18.4633 24.5926 15.7938 22.7099 14.8649 20.9383C13.936 19.1667 13.2074 16.7677 14.8649 13.5802C16.25 10.9167 19 10 21.218 10H28.1667V32Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_55_2125">
        <rect width="42" height="42" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>
<style scoped>
.icon .bg {
  transition: fill 0.3s;
}
.icon:hover .bg {
  fill: #fc3f1d;
}
</style>
